/**
 * Performance PDP subscription tier blocks — sync selection, qty, and prices to product form.
 */
(function () {
  var FORM_QTY_CLASS = "performance-pdp-tier-qty-active";

  function money(cents) {
    if (typeof window.Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function getForm(root) {
    var scope = root || document.getElementById("product-template");
    if (!scope) return null;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  function ensureSellingPlanInput(form) {
    var input = form.querySelector('[name="selling_plan"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      form.appendChild(input);
    }
    return input;
  }

  function ensureFormQty(form) {
    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = document.createElement("input");
      qty.type = "hidden";
      qty.name = "quantity";
      form.appendChild(qty);
    }
    return qty;
  }

  function parseIntSafe(v, fallback) {
    var n = parseInt(String(v), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function getTierQty(tier) {
    var el = tier.querySelector("[data-tier-qty-value]");
    if (!el) return parseIntSafe(tier.dataset.defaultQty, 1);
    return parseIntSafe(el.textContent, parseIntSafe(tier.dataset.defaultQty, 1));
  }

  function clampQty(tier, qty) {
    var min = parseIntSafe(tier.dataset.minQty, 1);
    var max = parseIntSafe(tier.dataset.maxQty, 0);
    var step = parseIntSafe(tier.dataset.qtyStep, 1);
    if (step < 1) step = 1;
    if (qty < min) qty = min;
    if (max > 0 && qty > max) qty = max;
    var stepsFromMin = Math.round((qty - min) / step);
    qty = min + stepsFromMin * step;
    if (max > 0 && qty > max) qty = max;
    if (qty < min) qty = min;
    return qty;
  }

  function updateTierDescription(tier) {
    var el = tier.querySelector("[data-tier-desc-text]");
    if (!el) return;
    var tpl = tier.dataset.descTemplate || "";
    if (!tpl) return;
    var qty = getTierQty(tier);
    var unit =
      qty === 1
        ? tier.dataset.unitSingular || "item"
        : tier.dataset.unitPlural || "items";
    var freq = tier.dataset.descFrequency || "monthly";
    var extra = tier.dataset.descExtra || "";
    var extraHtml = extra ? "<strong>" + extra + "</strong> " : "";
    el.innerHTML = tpl
      .replace(/\[quantity\]/g, String(qty))
      .replace(/\[unit\]/g, unit)
      .replace(/\[frequency\]/g, freq)
      .replace(/\[extra\]/g, extraHtml);
  }

  function updateTierPrices(tier) {
    var qty = getTierQty(tier);
    var unit = parseIntSafe(tier.dataset.unitPriceCents, 0);
    var compareUnit = parseIntSafe(tier.dataset.compareUnitCents, 0);
    var nowEl = tier.querySelector("[data-tier-price-now]");
    var wasEl = tier.querySelector("[data-tier-price-was]");
    if (nowEl && unit > 0) nowEl.textContent = money(unit * qty);
    if (wasEl) {
      if (compareUnit > unit) {
        wasEl.textContent = money(compareUnit * qty);
        wasEl.style.display = "";
      } else {
        wasEl.style.display = "none";
      }
    }
    var minus = tier.querySelector("[data-tier-qty-minus]");
    if (minus) minus.disabled = qty <= parseIntSafe(tier.dataset.minQty, 1);
    var plus = tier.querySelector("[data-tier-qty-plus]");
    var max = parseIntSafe(tier.dataset.maxQty, 0);
    if (plus) plus.disabled = max > 0 && qty >= max;
    updateTierDescription(tier);
  }

  function setActiveTier(tier, form) {
    if (!tier || !form) return;
    var root = tier.closest("#product-template") || document;
    root.classList.remove("performance-pdp--buy-once-selected");
    var discountProp = form.querySelector('[name="properties[Discount]"]');
    if (discountProp) discountProp.disabled = false;
    root.querySelectorAll("[data-performance-pdp-tier]").forEach(function (el) {
      el.classList.remove("performance-pdp-tier--active");
    });
    tier.classList.add("performance-pdp-tier--active");
    var radio = tier.querySelector("[data-performance-pdp-tier-radio]");
    if (radio) radio.checked = true;

    var planId = tier.dataset.sellingPlanId || "";
    ensureSellingPlanInput(form).value = planId;

    var qty = clampQty(tier, getTierQty(tier));
    var qtyEl = tier.querySelector("[data-tier-qty-value]");
    if (qtyEl) qtyEl.textContent = String(qty);
    ensureFormQty(form).value = String(qty);
    form.classList.add(FORM_QTY_CLASS);
    updateTierPrices(tier);
    if (typeof window.syncPerformanceMemberGifts === "function") {
      window.syncPerformanceMemberGifts(root);
    }
    if (typeof window.syncPerformanceStickyAtc === "function") {
      window.syncPerformanceStickyAtc();
    }
    document.dispatchEvent(
      new CustomEvent("performance-pdp:tier-changed", { detail: { tier: tier } })
    );
  }

  function initRoot(root) {
    var form = getForm(root);
    if (!form) return;
    var tiers = (root || document).querySelectorAll("[data-performance-pdp-tier]:not(.performance-pdp-tier--missing)");
    if (!tiers.length) return;

    var active =
      (root || document).querySelector(".performance-pdp-tier--active[data-performance-pdp-tier]") ||
      (root || document).querySelector("[data-performance-pdp-tier-radio]:checked")?.closest("[data-performance-pdp-tier]") ||
      tiers[0];

    if (active) setActiveTier(active, form);

    tiers.forEach(function (tier) {
      updateTierPrices(tier);
    });

    if (typeof window.syncPerformanceMemberGifts === "function") {
      window.syncPerformanceMemberGifts(root);
    }
  }

  document.addEventListener("click", function (e) {
    var tier = e.target.closest("[data-performance-pdp-tier]");
    if (!tier || tier.classList.contains("performance-pdp-tier--missing")) return;
    if (e.target.closest("[data-tier-qty-minus], [data-tier-qty-plus]")) return;

    var form = getForm(tier.closest("#product-template"));
    if (!form) return;
    setActiveTier(tier, form);
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-tier-qty-minus], [data-tier-qty-plus]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var tier = btn.closest("[data-performance-pdp-tier]");
    if (!tier) return;
    var form = getForm(tier.closest("#product-template"));
    if (!form) return;

    if (!tier.classList.contains("performance-pdp-tier--active")) {
      setActiveTier(tier, form);
    }

    var step = parseIntSafe(tier.dataset.qtyStep, 1);
    var qty = getTierQty(tier);
    if (btn.hasAttribute("data-tier-qty-minus")) qty -= step;
    else qty += step;
    qty = clampQty(tier, qty);
    var qtyEl = tier.querySelector("[data-tier-qty-value]");
    if (qtyEl) qtyEl.textContent = String(qty);
    ensureFormQty(form).value = String(qty);
    updateTierPrices(tier);
  });

  document.addEventListener("change", function (e) {
    var radio = e.target.closest("[data-performance-pdp-tier-radio]");
    if (!radio) return;
    var tier = radio.closest("[data-performance-pdp-tier]");
    var form = getForm(tier && tier.closest("#product-template"));
    if (tier && form) setActiveTier(tier, form);
  });

  window.addEventListener("variantChange.ecomify.product", function () {
    window.setTimeout(function () {
      initRoot(document.getElementById("product-template"));
    }, 80);
  });

  document.addEventListener("product:flavor-section-swapped", function (ev) {
    var sectionRoot = ev.detail && ev.detail.root;
    if (!sectionRoot) return;
    window.setTimeout(function () {
      initRoot(sectionRoot.querySelector("#product-template") || sectionRoot);
    }, 80);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initRoot(document.getElementById("product-template"));
    });
  } else {
    initRoot(document.getElementById("product-template"));
  }
})();
